var $obj = $('.GPC0082');

$(document).ready(function() {
	var parent_node = document.querySelectorAll('.GPC0082');
	if(!parent_node) return false;
	
	function GPC0082(){
		var component = GPC0082.prototype;
		component.obj = {
			elem : {
				slider : null
			},
			option : {
				slide : {
					infinite: false,
					listStyle: true, // WA-GPC0082-04
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows : true,
					dots: false,
					responsive : [
						{
							breakpoint : 767,
							settings : {
								arrows : false,
								dots: true
							}
						}
					]
				}
			}
		}
		component.init = function(){
			this.addEvent();
			this.addAriaDescribedby();
			//priceSyncGPC0082.init();
		}
		component.addEvent = function(){
			// DOM branch
			for(var a=0; a<parent_node.length; a++){
				var _this =  parent_node[a], 
					$this = $(_this);				
				for( var b=0; b<$this.length; b++ ){
					// event;
					this.slot($this);
					this.slide_generator( $this.find(".product-contents-cluster.on").children() );
				}
			}
		}
		component.addAriaDescribedby = function(){
			var els = $('.GPC0082');
			var waNumber = 0;
			$(els).find('.category-product-contents .item').each(function() {
				var $target;
				if($(this).find('.model-name a') && !$(this).find('.model-name a').is(':empty')) {
					$target = $(this).find('.model-name a');
				}
				if($target) {
					$target.attr('id', 'waGPC0082_'+waNumber);
					$(this).find('a.btn').attr('aria-describedby', 'waGPC0082_'+waNumber);
					waNumber++;
				}
			});
		}
		component.slide_generator = function(slider){
			if( slider.hasClass("slick-initialized") ){
				slider.slick("setPosition");
			}else{
				slider.slick(component.obj.option.slide);
			}
		}
		component.slot = function(selector){
			var el = selector;
			var options = {
				syncGroup : [
					[".list-slot-item", "active"],
					[".product-contents-cluster", "on"],
					[".btn-tab", "active"]
				],
				fullLength : el.find(".slot-belt").children().length,
				showLength : 6,
				activeIndex : 0,
				itemMargin : 0,
				areaPadding : (30+11+35),
				avg : 0,
				positionY : 0,
				rollDistace : 0,
				cutoff : 0,
				limit : {
					min : 0,
					max : 0
				}
			}
			// init
			preset();
			reflowEvent();
			UIEvent();

			// methods
			function calcHeight(){
				var extract = el.find(".category-product-contents").outerHeight(true);
				el.find(".list-slot-package").css({
					height : (extract - (options.areaPadding*2)) + "px"
				})

				options.avg = Math.ceil(el.find(".list-slot-package").height()/2);
				options.itemMargin = Number(window.getComputedStyle( document.querySelector(".list-slot-item"), null ).getPropertyValue("margin-top").split("px")[0])
				options.limit.max = Number( (el.find(".slot-belt").outerHeight(true) + options.itemMargin) - (options.avg)*2);
				options.cutoff = Number( el.find(".slot-belt").outerHeight(true) - options.avg );

				return(options.avg, options.limit.max, options.itemMargin, options.cutoff);
			}
			function positioning(posY){
				var midline = options.avg - (options.itemMargin*2);

				posY = Math.ceil(el.find(".list-slot-item").eq(options.activeIndex).position().top);
				
				options.rollDistace = -(posY - midline);
				
				if( Math.abs(posY) < options.avg ){
					options.rollDistace = options.limit.min
				} else if( Math.abs(posY) >= options.cutoff ) {
					options.rollDistace = -(options.limit.max)
				}

				options.positionY = posY;

				return(options.positionY, options.rollDistace);
			}
			function slotAnimate(distance){
                el.find(".slot-belt").css({
                    transform : "translateY(" + distance + "px)"
				})

				options.rollDistace = distance;

				return(options.rollDistace);
            }
			function watchIndex(element){
				options.activeIndex = element.parent('li').index(); /* PJTWAUS-1 : 20200115 add */

				for(var i=0; i<options.syncGroup.length; i++){
					el.find(options.syncGroup[i][0]).removeClass(options.syncGroup[i][1]);
					el.find(options.syncGroup[i][0]).eq(options.activeIndex).addClass(options.syncGroup[i][1]);
					if(options.syncGroup[i][0] != ".product-contents-cluster") {
						el.find(options.syncGroup[i][0]).attr({'aria-selected': false, 'tabindex': -1 });
						el.find(options.syncGroup[i][0]).eq(options.activeIndex).attr({'aria-selected': true, 'tabindex': 0 });
					}
				}
				component.slide_generator( el.find(".product-contents-cluster").eq(options.activeIndex).children() );
			}
			function disableHandler(){
				if(options.fullLength <= options.showLength ){
					el.find(".slot-handler").addClass("disabled");
				}
			}
			function disabledrolling(){
				el.find(".slot-handler").find("button").removeClass("disabled");
				/* LGEGMC-243 20200528 */
				var $activeLi =  el.find(".category-list-slot button.active").parent();
				// if( options.rollDistace === 0 ){
				if ( $activeLi.is(':first-child') ) {
					el.find(".slot-prev").addClass("disabled").attr('aria-disabled',true); //PJTWAUS-1 : 20200115 modify
				}else{
					el.find(".slot-prev").attr('aria-disabled',false); //PJTWAUS-1 : 20200115 add
				}
				//if(Math.abs(options.rollDistace) === options.limit.max){
				if ( $activeLi.is(':last-child') ) {
					el.find(".slot-next").addClass("disabled").attr('aria-disabled',true); //PJTWAUS-1 : 20200115 modify
				}else{
					el.find(".slot-next").attr('aria-disabled',false); //PJTWAUS-1 : 20200115 add
				}
				/* // LGEGMC-243 20200528 */
			}
			function disabledMotion(tg, boundWidth){
				if( tg.hasClass("disabled") ){
					el.find(".slot-belt").addClass("banding");
					slotAnimate( (options.rollDistace + boundWidth) );
					setTimeout(function(){
						el.find(".slot-belt").removeClass("banding");
						slotAnimate( (options.rollDistace - boundWidth) );
						tg.addClass("disabled");	// prevent to termainate "disabled"
					}, 300);
				}
			}
			function preset(){
				el.find(".list-slot-item").attr({'aria-selected': false, 'tabindex': -1 }); /* LGEGMC-243 20200520 */
				el.find(".list-slot-item").first().addClass("active").attr({'aria-selected': true, 'tabindex': 0 }); /* LGEGMC-243 20200520 */
				calcHeight();
				slotAnimate(0);
				disableHandler();
				disabledrolling();
			}

			// event;
			function reflowEvent(){
				$(window).on("resize", function(){
					calcHeight();
					positioning(options.positionY);
					slotAnimate(options.rollDistace);
					disabledrolling();
				})
			}
			function UIEvent(){

				el.find(".slot-handler").on("click touch", "button", function(){
					var $this = $(this);
					var $parentLi = el.find(".category-list-slot .list-slot-item.active").parent();
					// adjust by case
					if( $this.hasClass("slot-prev")){
						
						/* LGEGMC-243 20200528 */
						// disabledMotion($this, options.itemMargin);
						if ( (!$parentLi.is(':first-child')) && (!$this.hasClass("disabled")) ) {
							$parentLi.prev().children().trigger('click').focus();
						}
						// options.rollDistace = -(Math.abs(options.rollDistace) - (options.avg*2));
						// if( options.rollDistace >= 0 ){
						// 	options.rollDistace = 0;
						// }
						/* // LGEGMC-243 20200528 */
					}
					if( $this.hasClass("slot-next")){
						
						/* LGEGMC-243 20200528 */
						/* disabledMotion($this, (-options.itemMargin)); */
						if ( (!$parentLi.is(':last-child')) && (!$this.hasClass("disabled")) ) {
							$parentLi.next().children().trigger('click').focus();
						}
						
						// options.rollDistace = -(Math.abs(options.rollDistace) + (options.avg*2));
						// if( Math.abs(options.rollDistace) >= options.limit.max ){
						// 	options.rollDistace = -(options.limit.max);
						// }
						/* // LGEGMC-243 20200528 */
					}
					//slotAnimate(options.rollDistace); /* // LGEGMC-243 20200528 */
					disabledrolling();
				});

				el.find(".category-list-slot").on("click touch", ".list-slot-item", function(){
					var $this = $(this);
					watchIndex($this);

					if(options.fullLength > options.showLength ){
						positioning(options.positionY);
						slotAnimate(options.rollDistace);
						disabledrolling();
					}
				});
				/* LGEGMC-243 20200520 */
				el.find(".category-list-slot").on("keydown", ".list-slot-item",function(e){
					var $parent = $(this).parent();
					if ((e.which === 37 || e.which === 38)) {
						e.preventDefault();
						if ( $parent.is(':first-child') ){
							$parent.siblings().last().children().trigger('click').focus();
						} else {
							$parent.prev().children().trigger('click').focus();
						}
						//console.log( $parent.is(':first-child'));
						//console.log('top');
					}
					if ((e.which === 39 || e.which === 40)) {
						e.preventDefault();
						if ( $parent.is(':last-child') ){
							$parent.siblings().first().children().trigger('click').focus();
						} else {
							$parent.next().children().trigger('click').focus();
						}
						//console.log( $parent.is(':last-child') );
						//console.log('bottom');
					}
				});
				/* // LGEGMC-243 20200520 */
				el.find(".tab-area").on("click touch", ".btn-tab", function(){
					var $this = $(this);
					watchIndex($this);

					if(options.fullLength > options.showLength ){
						positioning(options.positionY);
						slotAnimate(options.rollDistace);
						disabledrolling();
					}
					// 20200511 START 이상현 - 선택한 tab이 늘 정위치에 오도록 수정
					// scrolling
					setActiveScroll($this.closest(".tab-outer"));	// mScrollbar.js custom method
					// 20200511 END
				});
			}
		}
		
		//LGEGMC-383
		//file download
		var fileDownload = function($link) {
			if($('form#formDown').length>0) $('form#formDown').remove();

			var fileBox = $link.closest('[data-file-download]');
			var flag = (fileBox.data('flag') || '').toUpperCase();
			var downtime = fileBox.data('downtime') || null;
			var opentime = fileBox.data('opentime') || null;

			if(flag=='Y') {
				// downtime error
				var $errorPop = $('#htmlOpenError');
				if($errorPop.length>0) {
					$errorPop.modal();
					$errorPop.find('.htmldowntime').text(downtime);
					$errorPop.find('.htmlopentime').text(opentime);
				} else {
					console.log('#htmlOpenError is required in HTML');
				}
			} else {

				var doc = $link.data('doc'),
					file = $link.data('file'),
					original = $link.data('original'),
					category = $link.data('category');

				var input = '<input type="hidden" id="DOC_ID" name="DOC_ID" value="' + doc +'" />';
				input += '<input type="hidden" id="ORIGINAL_NAME_b1_a1" name="ORIGINAL_NAME_b1_a1" value="' + original +'" />';
				input += '<input type="hidden" id="FILE_NAME" name="FILE_NAME" value="' + file +'" />';
				input += '<input type="hidden" id="TC" name="TC" value="DwnCmd" />';
				input += '<input type="hidden" id="GSRI_DOC" name="GSRI_DOC" value="GSRI" />'
				input += '<input type="hidden" id="SPEC_DOWNLOAD" name="SPEC_DOWNLOAD" value="N" />';

				/*LGEGMC-1035 start*/
	            var openlocale="|AR|AT|BE_FR|BG|CH_DE|CH_FR|CZ|DE|DK|EE|ES|FI|FR|GR|HR|HU|IT|LT|LV|NL|NO|PL|PT|RO|RS|SE|SK|UA|UK|AE|AE_AR|";
	            var _target="_self";
	            if((original.toLowerCase().indexOf('.pdf')>-1 || original.toLowerCase().indexOf('.bmp')>-1 || original.toLowerCase().indexOf('.jpg')>-1 || original.toLowerCase().indexOf('.jpeg')>-1||original.toLowerCase().indexOf('.png')>-1) && openlocale.indexOf("|"+COUNTRY_CODE.toUpperCase()+"|")>-1){
	            	_target="_blank";
	            }
	            
				var form = $('<form />').attr({
					id: 'formDown',
					method: 'get',
					action: fileBox.data('action'),
					target: _target
				}).append(input);
				$('body').append(form);
				/*LGEGMC-1035 end*/

				$('#formDown').submit();
			}
		}
		
		
		$obj.on('click','.file-list a.link-text',function(e){
			e.preventDefault();
			fileDownload($(this));
		});
		component.init();
	}
	
	GPC0082();
	
	
	/* LGEITF-604 Start */
	const priceSyncGPC0082 = {
		el: $obj,
		priceTemplate: null,
		obsPriceTemplate: null, // LGEITF-853
		stockTemplate: null,
		init: function(){
			const _this = this;
			
			_this.priceTemplate = $('#priceTemplateGPC0082').clone().html();
			_this.obsPriceTemplate = $('#obsPriceTemplateGPC0082').clone().html(); // LGEITF-853
			$('#priceTemplateGPC0082').remove();
			_this.stockTemplate = $('#stockTemplateGPC0082').clone().html();
			$('#stockTemplateGPC0082').remove();
			_this.getPrice();
		},
		getPrice: function(){
			const _this = this;
			const modelIds = new Array();
			const contentsArea = _this.el.find('.category-product-contents .product-contents-cluster');
			
			contentsArea.find('.model-info').each(function(idx) {
				modelIds[idx] = $(this).data('model-id');
			});
			
			const url = _this.el.data('price-sync-url'),
				param = {
					modelIds: modelIds.join()
				};
				
			ajax.call(url, param, 'json', function(data){
				if(data.status == 'success' && data.data){
					const responseData = data.data[0];
					const productList = responseData.productList;
					const productMessages = responseData.productMessages;
					
					let commonData = {};
					commonData.outOfStockText = productMessages.outOfStockText;
					commonData.limitSaleSoldOutText = productMessages.limitSaleSoldOutText;
					commonData.limitSaleTitle = productMessages.limitSaleTitle;
					commonData.limitSaleUseFlag = responseData.limitSaleUseFlag;
					commonData.reStockFuncFlag = responseData.reStockFuncFlag;
					commonData.obsInstallmentPriceDisableLink  = responseData.obsInstallmentPriceDisableLink ;	// LGETW-651 add
					if(!!commonData.obsInstallmentPriceDisableLink && commonData.obsInstallmentPriceDisableLink == 'Y') $obj.find('.price-installment').addClass('no-link').attr('tabindex','-1');	// LGETW-651 add
					/* LGCOMPA-44 start */
					if(!!responseData.guestPriceMessageUseFlag && responseData.guestPriceMessageUseFlag == 'Y'){
						commonData.guestPriceMessageUseFlag = responseData.guestPriceMessageUseFlag;
						commonData.guestPriceMessage = responseData.guestPriceMessage;
					}
					/* LGCOMPA-44 end */
					//const $targetSelector = $obj.find('.product-list-box.promotion-box').find('.promotion-list-box[categoryid='+responseCategoryId+']');
						
					for (var i=0; i<productList.length; i++) {
						const p = productList[i];
						const priceSyncHtml = priceSyncGPC0082.priceTemplate;
						const obsPriceSyncHtml = priceSyncGPC0082.obsPriceTemplate; // LGEITF-853
						const stockSyncHtml = priceSyncGPC0082.stockTemplate;
	
						if (priceSyncHtml) {
							const $template = _this.makePriceSyncHtml(p, commonData, priceSyncHtml);
							const $obsPricetemplate = _this.makePriceSyncHtml(p, commonData, obsPriceSyncHtml); // LGEITF-853
							const $stockTemplate = _this.makeStockSyncHtml(p, commonData, stockSyncHtml);
							const scop = contentsArea.find('.model-info[data-model-id='+p.modelId+']');
							scop.find('.detail-info .price-area').prepend($template);
							scop.find('.detail-info .price-area').after($obsPricetemplate); // LGEITF-853
							scop.find('.detail-info .btn-area').before($stockTemplate);
							//scop.find('.detail-info .stock-area').prepend($template);
							//scop.find('.price-pdp-Installment, .purchase-price, .retailer, .stock-area, .member-price').removeClass('d-none');
						}
					}
				}
			});
		},
		makePriceSyncHtml : function(p, commonData, template){
			if (template) {
				const emiMsgFlag = !!p.obsEmiMsgFlag && p.obsEmiMsgFlag == 'Y',
					emiMsgAreaYn = !!p.emiMsgAreaYn && p.emiMsgAreaYn == 'Y',
					afterPay = p.afterPay,
					obsMembershipLinkTarget = commonData.obsMembershipLinkTarget,
					obsMembershipLinkUrl = commonData.obsMembershipLinkUrl,
					limitSaleUseFlag = !!commonData.limitSaleUseFlag && commonData.limitSaleUseFlag == 'Y',
					rPrice = p.rPrice,
					rPriceCent = p.rPriceCent,
					rPromoPrice = p.rPromoPrice,
					rPromoPriceCent = p.rPromoPriceCent,
					discountMsg = p.discountMsg,
					bizType = p.bizType,
					obsInventoryFlag = !!p.obsInventoryFlag && p.obsInventoryFlag == 'Y',
					obsLimitSale = !!p.obsLimitSale && p.obsLimitSale == 'Y',
					obsLoginFlag = !!p.obsLoginFlag && p.obsLoginFlag ? 'Y' : 'N',
					modelStatusCode = p.modelStatusCode,
					title = obsMembershipLinkTarget == '_blank' ? $obj.find('input#openTarget').val() : '';
					
				let tempPrice = '',
					tempPromoPrice = '',
					tempLegal = ''
					obsMemberShipLinkStartHtml = '',
					obsMemberShipLinkEndHtml = '',	
					soldOutText = '';
					
				if (!!obsMembershipLinkUrl && p.membershipDisplayFlag == 'Y') {
					obsMemberShipLinkStartHtml = "<a href='"+ obsMembershipLinkUrl +"' target='"+ obsMembershipLinkTarget +"' title='" +title+ "'>";
					obsMemberShipLinkEndHtml = "</a>";
				}
				
				template = template.replace(/\*modelId\*/g, p.modelId)
				.replace(/\*retailerPricingText\*/g, !!p.retailerPricingText ? p.retailerPricingText : '')
				.replace(/\*emiPopUrl\*/g, !!commonData.emiPopupUrl ? commonData.emiPopupUrl : '')
				.replace(/\*emiMsg\*/g, emiMsgFlag ? p.emiMsg : '')
				.replace(/\*display\*/g, emiMsgFlag && (afterPay > 0 && afterPay <= 3000) ? '' : 'style="display:none;"')
				.replace(/\*zipdisplay\*/g, emiMsgFlag && (afterPay > 0 && afterPay <= 10000) ? '' : 'style="display:none;"') /* OBSLGEAU-749 (5000 -> 10000) */
				.replace(/\*orZipPay\*/g, emiMsgFlag && (afterPay > 0 && afterPay <= 3000) ? 'or ' : '')
				.replace(/\*zipPayInstallMent\*/g, emiMsgFlag && (afterPay > 0 && afterPay <= 10000) ? 'afterpay-installment" href="#modal-afterpay' : '" style="display:none;') /* OBSLGEAU-749 (5000 -> 10000) */
				.replace(/\*afterPayInstallMent\*/g, emiMsgFlag && !!p.emiMsg && (afterPay <= 3000 && afterPay > 0) ? 'afterpay-installment" href="#modal-afterpay' : '" style="display:none;')
				.replace(/\*msrp\*/g, nvl(p.msrp,'0'))
				.replace(/\*obsMembershipLinkUrl\*/g, obsMembershipLinkUrl)
				.replace(/\*membershipDisplayFlag\*/g, p.membershipDisplayFlag)
				.replace(/\*limitSaleTitle\*/g, limitSaleUseFlag && obsLimitSale ? commonData.limitSaleTitle : '')
				.replace(/\*obsMembershipLinkTarget\*/g, !!obsMembershipLinkTarget ? obsMembershipLinkTarget : '')
				.replace(/\*membershipPrice\*/g, !!p.rMembershipPriceCent ? changeFormatFullPriceSync(p.rMembershipPrice, p.rMembershipPriceCent) : (!!p.rMembershipPrice ? changeFormatPriceSync(p.rMembershipPrice) : ''))
				.replace(/\*obsMemberShipLinkStart\*/g,obsMemberShipLinkStartHtml)
				.replace(/\*obsMemberShipLinkEnd\*/g,obsMemberShipLinkEndHtml)
				.replace(/\*calculatorSalesCode\*/g, (p.salesModelCode != null && p.salesModelCode != "") && (p.salesSuffixCode != null && p.salesSuffixCode != "") ? p.salesModelCode+"."+p.salesSuffixCode : p.salesModelCode);
				
				// Price
				if (modelStatusCode == 'ACTIVE') {
					if (!!rPromoPriceCent) {
						tempPrice = changeFormatFullPriceSync(rPromoPrice, rPromoPriceCent);
						tempPromoPrice = changeFormatFullPriceSync(rPrice, rPriceCent);
						tempLegal = discountMsg;
					} else if (!!rPromoPrice) {
						tempPrice = changeFormatFullPriceSync(rPromoPrice);
						tempPromoPrice = changeFormatFullPriceSync(rPrice);
						tempLegal = discountMsg;
					} else if (!!rPriceCent) {
						tempPrice = changeFormatFullPriceSync(rPrice, rPriceCent);
					} else if (!!rPrice) {
						tempPrice = changeFormatFullPriceSync(rPrice);
					}
				}
				
				let $html = $(template);
				
				// Setting
				if (modelStatusCode == 'ACTIVE') {
					$html.find('.selling-price .number').text(tempPrice);
					$html.find('.production-price .number').text(tempPromoPrice);
					$html.find('.production-price .legal').html(!!tempLegal ? tempLegal.replace(/&lt;/gi, '<').replace(/&gt;/gi, '>') : '');
				}
				if (limitSaleUseFlag && obsLimitSale) {
					$html.find('.price-vip-Installment .price-vip').text(commonData.limitSaleTitle); // LGEITF-805 
				}
				
				// Delete
				if (bizType != 'B2B' || (bizType == 'B2B' && obsLoginFlag == 'Y') || ( obsLoginFlag == 'N' && !!!rPrice)) {
					$html.find('div.msrp').remove();
				}
				if (!!p.membershipDisplayFlag && p.membershipDisplayFlag != 'Y') {
					$html.find('.member-price').empty();
				}
				if (!!p.retailerPricingFlag && p.retailerPricingFlag != 'Y') {
					$html.find('div.retailer').remove();
				}
				if (afterPay <= 0 || p.obsInventoryFlag != 'Y') {
					$html.find('.price-pdp-Installment > a.afterpay-installment').remove();
				}
				if (!emiMsgAreaYn || !emiMsgFlag) {
					$html.find('.price-pdp-Installment').children().not('.price-vip').remove();
				}
				if (!!!tempPromoPrice) {
					$html.find('.production-price').remove();
				}
				if (modelStatusCode != 'ACTIVE' || (!!!tempPromoPrice && !!!tempPrice)) {
					$html.find('.purchase-price').remove();
				}
				
				/* LGETW-651 start */
				if(!!commonData.obsInstallmentPriceDisableLink && commonData.obsInstallmentPriceDisableLink == 'Y'){
					$html.find('.price-installment').addClass('no-link').attr('tabindex','-1');
				}
				/* LGETW-651 end */
				
				/* LGCOMPA-44 start */
				if(  SIGN_IN_STATUS == 'N'
				  && !!p.membershipDisplayFlag
				  &&   p.membershipDisplayFlag == 'Y'
				  && !!commonData.guestPriceMessageUseFlag
				  &&   commonData.guestPriceMessageUseFlag == 'Y'
				  && !!commonData.guestPriceMessage){
					$html.find('.member-price').html('').append(commonData.guestPriceMessage);
				}
				/* LGCOMPA-44 end */

				//LGCOMPL-218 start
				if ( p.obsLowestPriceFlag == 'Y' && !!p.rPromoPrice ) {
					if ( $html.find('.lowest-price-mark').length ) $html.find('.lowest-price-mark').removeClass('d-none');
					if ( $html.find('.lowest-price-box').length ) $html.find('.lowest-price-box').removeClass('d-none'); 
				} else {
					if ( $html.find('.lowest-price-mark').length ) $html.find('.lowest-price-mark').html('');
					if ( $html.find('.lowest-price-box').length ) $html.find('.lowest-price-box').html('');
				}
				//LGCOMPL-218 end
				
				return $html.html();
			}
		},
		makeStockSyncHtml : function(p, commonData, template){
			if (template) {
				const limitSaleUseFlag = !!commonData.limitSaleUseFlag && commonData.limitSaleUseFlag == 'Y',
					reStockFuncFlag = commonData.reStockFuncFlag,
					obsLimitSale = !!p.obsLimitSale && p.obsLimitSale == 'Y',
					obsInventoryFlag = !!p.obsInventoryFlag && p.obsInventoryFlag == 'Y',
					reStockAlertFlag = !!p.reStockAlertFlag && p.reStockAlertFlag == 'Y',
					isOutOfStock = (reStockAlertFlag || limitSaleUseFlag) ? 'out-of-stock' : '';
					
				let soldOutText = '';
				if (limitSaleUseFlag && obsLimitSale && !obsInventoryFlag) {
					soldOutText = commonData.limitSaleSoldOutText;
				} else if (reStockAlertFlag) {
					soldOutText = commonData.outOfStockText;
				}
				
				template = template.replace(/\*outOfStock\*/g, isOutOfStock);
				
				let $html = $(template);
				
				if ((limitSaleUseFlag && obsLimitSale && !obsInventoryFlag) || reStockAlertFlag) {
					$html.find('.stock-area .text').text(soldOutText);
				} else {
					$html.find('.stock-area').empty();
				}
				
				if (reStockFuncFlag != 'Y' && limitSaleUseFlag != 'Y') {
					$html.find('.stock-area').remove();
				}
				
				return $html.html();
			}
		}
	}
	
	var observer = new MutationObserver(function(mutations) {
		mutations.forEach(function(mutation) {
			if (mutation.attributeName === 'data-is-vip') {
				priceSyncSet(mutation.target.getAttribute('data-is-vip'));
				observer.disconnect();
			}
		});
	});
	observer.observe(document.querySelector('.GPC0082'), {
		attributes: true, childList: false, characterData: false
	});
	
	if($obj.attr('data-is-vip') != 'NULL'){
		priceSyncSet($obj.attr('data-is-vip'));
		observer.disconnect();		
	}
	
	function priceSyncSet(flag){
		if(flag == 'false'){
			priceSyncGPC0082.init();
		}else{
			// LGEPL-697 Start
			// for VIP user :: display B2C price after fetch vip price
			priceSyncGPC0082.el.find('.detail-info').find('.purchase-price.d-none').removeClass('d-none');
			priceSyncGPC0082.el.find('.detail-info').find('.member-price.d-none').removeClass('d-none');
			priceSyncGPC0082.el.find('.detail-info').find('.stock-area.d-none').removeClass('d-none');
			// LGEPL-697 End
		}
	}
	/* //LGEITF-604 End */
});

